import { Form, Select } from 'antd';
import type { FormItemProps } from 'antd';

import { CustomInput } from 'app/components/fields/Input';
import { parseInputNumber } from 'app/utils/typing';

import './NumberWithUnit.scss';

const { Option } = Select;

type UnitOption =
  | string
  | { key?: string; value: string; label: string }
  | { label: string; value: string };

type NumberWithUnitProps = {
  numberFormName: string;
  unitFormName: string;
  disabled: boolean;
  min?: number;
  parser?: (value?: string) => string | number;
  unitOptions: UnitOption[];
  isSmallSelect?: boolean;
  unitFormCondition?: boolean;
  showSearch?: boolean;
  unitFormItemProps?: Pick<FormItemProps, 'rules' | 'dependencies'>;
};

export const NumberWithUnit = ({
  numberFormName,
  unitFormName,
  disabled,
  min = 0,
  parser = parseInputNumber,
  unitOptions,
  isSmallSelect = false,
  unitFormCondition = true,
  showSearch = false,
  unitFormItemProps,
}: NumberWithUnitProps) => (
  <div className="number-with-unit">
    <Form.Item name={numberFormName} className="number">
      <CustomInput
        onWheel={(e) => e.currentTarget.blur()}
        min={min}
        parser={parser}
        disabled={disabled}
      />
    </Form.Item>
    {unitFormCondition && (
      <Form.Item name={unitFormName} className="unit" {...unitFormItemProps}>
        <Select
          className={isSmallSelect ? 'small-select' : undefined}
          disabled={disabled}
          showSearch={showSearch}
        >
          {unitOptions.map((opt) => {
            if (typeof opt === 'string') {
              return (
                <Option key={opt} value={opt}>
                  {opt}
                </Option>
              );
            }

            const { value, label, key } = opt as {
              key?: string;
              value: string;
              label: string;
            };
            const optionValue = value ?? label;
            const optionLabel = label ?? value ?? String(optionValue);
            const optionKey = key ?? optionValue;

            return (
              <Option key={optionKey} value={optionValue}>
                {optionLabel}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    )}
  </div>
);
